//# sourceMappingURL=status.mjs.map
/// <reference types="./status.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class InProgress extends $CustomType {}
export const Status$InProgress = () => new InProgress();
export const Status$isInProgress = (value) => value instanceof InProgress;

export class Won extends $CustomType {}
export const Status$Won = () => new Won();
export const Status$isWon = (value) => value instanceof Won;

export class Lost extends $CustomType {}
export const Status$Lost = () => new Lost();
export const Status$isLost = (value) => value instanceof Lost;

export class Submitted extends $CustomType {}
export const Status$Submitted = () => new Submitted();
export const Status$isSubmitted = (value) => value instanceof Submitted;

export class Cancelled extends $CustomType {}
export const Status$Cancelled = () => new Cancelled();
export const Status$isCancelled = (value) => value instanceof Cancelled;

export class Draft extends $CustomType {}
export const Status$Draft = () => new Draft();
export const Status$isDraft = (value) => value instanceof Draft;

export const all = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Submitted(),
  /* @__PURE__ */ new Won(),
  /* @__PURE__ */ new Lost(),
  /* @__PURE__ */ new Cancelled(),
  /* @__PURE__ */ new InProgress(),
  /* @__PURE__ */ new Draft(),
]);

export function is_ongoing(status) {
  return (status instanceof InProgress) || (status instanceof Draft);
}

export function is_finished(status) {
  return !is_ongoing(status);
}

export function to_string(status) {
  if (status instanceof InProgress) {
    return "In progress";
  } else if (status instanceof Won) {
    return "Won";
  } else if (status instanceof Lost) {
    return "Lost";
  } else if (status instanceof Submitted) {
    return "Submitted";
  } else if (status instanceof Cancelled) {
    return "Cancelled";
  } else {
    return "Draft";
  }
}

export function to_json_string(status) {
  if (status instanceof InProgress) {
    return "in-progress";
  } else if (status instanceof Won) {
    return "won";
  } else if (status instanceof Lost) {
    return "lost";
  } else if (status instanceof Submitted) {
    return "submitted";
  } else if (status instanceof Cancelled) {
    return "cancelled";
  } else {
    return "draft";
  }
}

export function encode(status) {
  let _pipe = status;
  let _pipe$1 = to_json_string(_pipe);
  return $json.string(_pipe$1);
}

export function decoder() {
  return $decode.then$(
    $decode.string,
    (content) => {
      if (content === "in-progress") {
        return $decode.success(new InProgress());
      } else if (content === "won") {
        return $decode.success(new Won());
      } else if (content === "lost") {
        return $decode.success(new Lost());
      } else if (content === "submitted") {
        return $decode.success(new Submitted());
      } else if (content === "cancelled") {
        return $decode.success(new Cancelled());
      } else if (content === "draft") {
        return $decode.success(new Draft());
      } else {
        return $decode.failure(new InProgress(), "Status");
      }
    },
  );
}
